// Package Imports
const { Form } = require("mobx-react-form");
import dvr from "mobx-react-form/lib/validators/DVR";
import validatorjs from "validatorjs";

// Project Imports
import Utils from "./utils";
import formObserver from './observers';
import setInitialDefaults from './initialDefault';
import * as Constants from 'constants/Constants';
import * as keys from './keys'
import moment from "moment";

class FlexiDreamPlanFormController extends Form {
  plugins() {
    return {
      dvr: dvr(validatorjs),
    };
  }

  setup() {
    return {
      fields: [
             {
               name: "plan-option",
               label: "Plan Option",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [],
               },
             },
             {
               name: "two-gether-option",
               label: "Two-gether Option",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [
                   { label: 'Yes', id: 22 },
                   { label: 'No', id: 23 },
                 ],
               },
             },
             {
               name: "premium-term",
               label: "Premium Paying Term",
               placeholder: "",
               extra: {
                 optionList: [],
               },
             },
     
             {
               name: "policy-term",
               label: "Policy Term",
               placeholder: "",
               value: '',
               extra: {
                 optionList: [
                   { label: 'Up to Age 100', id: '100 - @LI_ENTRY_AGE' },
                   { label: '25', id: 25 },
                   { label: '30', id: 30 },
                   { label: '40', id: 40 },
                 ],
               },
             },
     
             {
               name: "payment-frequency",
               label: "Premium Paying Frequency",
               placeholder: "",
               extra: {
                 optionList: [
                   { label: 'Annual', id: "1" },
                   { label: 'Semi-Annual', id: "2" },
                   { label: 'Quarterly', id: "3" },
                   { label: 'Monthly', id: "4" }
                 ]
               },
             },
             {
               name: "income-frequency-mode",
               label: "Income Frequency Mode",
               placeholder: "",
               extra: {
                 optionList: []
               },
             },
     
             {
               name: "accrual-of-survival-benefit",
               label: "Accrual Of Survival Benefits",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [],
                 hide: false
               },
             },
             {
               name: "asb-start-age-(1st-opt-in)",
               label: "Start Policy Year (1st Opt In)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
     
                 ],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 31)
               },
     
             },
     
             {
               name: "asb-end-age-(1st-opt-in)",
               label: "End Policy Year (1st Opt-Out)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
     
                 ],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 132)
               },
     
             },
             {
               name: "withdrawal-parcentage-1",
               label: "Withdrawal Percentage (1st Opt-Out)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForWithDrawalParcentage(0, 233)
               },
     
             },
             {
               name: "accrual-of-survival-benefits-year-2",
               label: "Accrual Of Survival Benefits Year 2",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
                   { label: 'Yes', id: 315 },
                   { label: 'No', id: 316 }
     
                 ],
                 hide: false,
               },
     
             },
     
             {
               name: "asb-start-age-(2nd-opt-in)",
               label: "Start Age ( 2nd Opt In)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
     
                 ],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 317)
               },
     
             },
     
             {
               name: "asb-end-age-(2nd-opt-in)",
               label: "End Age ( 2nd Opt In)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
     
                 ],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 418)
               },
     
             },
             {
               name: "withdrawal-parcentage-2",
               label: "WithDrawal Parcentage ( 2st Opt In)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
     
                 ],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForWithDrawalParcentage(0, 519)
               },
     
             },
             {
               name: "accrual-of-survival-benefits-year-3",
               label: "Accrual Of Survival Benefits Year 3",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
                   { label: 'Yes', id: 620 },
                   { label: 'No', id: 621 }
     
                 ],
                 hide: false
               },
     
             },
     
             {
               name: "asb-start-age-(3rd-opt-in)",
               label: "Start Age ( 3rd Opt In)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
     
                 ],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 622)
               },
     
             },
     
             {
               name: "asb-end-age-(3rd-opt-in)",
               label: "End Age ( 3rd Opt In)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
     
                 ],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 723)
               },
     
             },
             {
               name: "withdrawal-parcentage-3",
               label: "WithDrawal Parcentage ( 3st Opt In)",
               placeholder: "",
               disabled: false,
               value: "",
               extra: {
                 optionList: [
     
                 ],
                 hide: false,
                 preDefinedOptList: Utils.generatePredefinedOptListForWithDrawalParcentage(0, 824)
               },
     
             },
             {
               name: "second-life-assured-first-name",
               label: "Second Life Assured First Name",
               placeholder: "",
               disabled: false,
               extra: {
                 hide: false,
                 onSecondLANameChange(form, data) {
                   let name = form.$('second-life-assured-first-name').value
                   Utils.updateBi(keys.SECOND_LIFE_ASSURED_NAME, name,data.data.package_id, form, data)
                 }
               },
             },
             {
               name: "second-life-assured-last-name",
               label: "Second Life Assured Last Name",
               placeholder: "",
               disabled: false,
               extra: {
                 hide: false,
                 onSecondLANameChange(form, data) {
                   let name = form.$('second-life-assured-last-name').value
                   Utils.updateBi(keys.SECOND_LIFE_ASSURED_LAST_NAME, name,data.data.package_id, form, data)
                 }
               },
             },
     
             {
               name: "second-life-assured-dob",
               label: "Second Life Assured DOB",
               placeholder: "Second Life Assured DOB",
               extra: {
                 onSecondLADobChange(value, form, data) {
     
                   form.$("second-life-assured-dob").set("value", value);
                   let childDob = value
                   let formatedChildDob = childDob
                   // let childDob = moment(value).year();
                   // let currentYear = moment().year();
                   // let age = currentYear - childDob;
                   // let isvalidate = moment(childDob, 'DD-MM-YYYY', true).isValid()
                   //  if (isvalidate) {
                   //   formatedChildDob = moment(childDob, 'DD-MM-YYYY').format('YYYY-MM-DD')
                   //  } else {
                   //     formatedChildDob = moment(childDob).format('YYYY-MM-DD')
                   //  }
                   // let childAge =  moment().diff(moment(formatedChildDob), "years")
     
                   let secondaryLADob = moment(childDob, 'DD-MM-YYYY').format("YYYY-MM-DD")
     
                   Utils.updateBi(keys.SecLaDOB, secondaryLADob,data.data.package_id, form, data);
                 },
               },
             },
             // {
             //   name: "second-life-assured-dob",
             //   label: "Second Life Assured DOB",
             //   placeholder: "",
             //   disabled: false,
             //   extra: {
             //     hide: false,
             //     onSecondLADobChange(form, data) {
             //       let name = form.$('second-life-assured-dob').value
             //       Utils.updateBi(keys.SECOND_LIFE_ASSURED_DOB, name,data.data.package_id, form, data)
             //     }
             //   },
             // },
             {
               name: "second-life-assured-gender",
               label: "Second Life Assured Gender",
               placeholder: "",
               disabled: false,
               extra: {
                 hide: false,
                 optionList: [
                   { label: 'Male', id: "27" },
                   { label: 'Female', id: "28" }
                 ],
               },
             },
             {
               name: "income",
               label: "Income",
               placeholder: "",
               disabled: true,
             },
             {
               name: "premium",
               label: "Premium",
               placeholder: "",
               disabled: true,
               extra: {
                 calculatePremium(form, data) { },
               },
             },
             {
               name: "maturity-benefit-payment-mode",
               label: "Maturity Benefit Payment mode",
               placeholder: "",
               extra: {
                 optionList: [
                   { label: 'Lumpsum', id: "928" },
                   { label: 'Monthly Income', id: "929" },
                   { label: 'Lumpsum Plus Monthly Income', id: "930" },
                 ]
               },
             },
     
             {
               name: "maturity-benefit-lumpsum-percentage",
               label: "Maturity Benefit Lumpsum %",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: Utils.generatePredefinedOptListForBenefitLumpsumParcentage(1, 931)
               },
             },
     
             {
               name: "number-of-months-maturity-benefit-paid",
               label: "Number of Months Maturity Benefit is paid",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [
                   { label: '36', id: 1030 },
                   { label: '60', id: 1031 },
                 ]
               },
             },
     
             {
               name: "death-benefit-payment-mode",
               label: "Death Benefit Payment mode",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [
                   { label: 'Lumpsum', id: "1032" },
                   { label: 'Monthly Income', id: "1033" },
                   { label: 'Lumpsum Plus Monthly Income', id: "1034" },
                 ]
               },
             },
     
             {
               name: "death-benefit-lumpsum-percentage",
               label: "Death Benefit Lumpsum %",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: Utils.generatePredefinedOptListForBenefitLumpsumParcentage(1, 1035)
               },
             },
             {
               name: "number-of-months-death-benefit-paid",
               label: "Number of Months Death Benefit is paid",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [
                   { label: '36', id: 1134 },
                   { label: '60', id: 1135 },
                 ]
               },
             },
             {
               name: "survival-benefit-advance",
               label: "Option to receive the Survival Benefit in advance",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: []
               },
             },
             {
               name: "total-survival-benefit",
               label: "Total Survival Benefit @8%",
               placeholder: "",
               disabled: false,
             },
             {
               name: "death-benefit-option",
               label: "Death Benefit Option",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [
                   { label: 'Option 1', id: 24 },
                   { label: 'Option 2', id: 25 }
                 ]
               },
             },
             {
               name: "proposition",
               label: "Proposition",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: []
               },
             },
             {
               name: "auto-renewal-booster",
               label: "Auto Renewal Booster applicable (ENACH)?",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [
                   { label: 'Yes', id: 1 },
                   { label: 'No', id: 0 },
                 ]
               },
             },
              {
               name: "is-existing-customer",
               label: "Is Existing Customer",
               placeholder: "",
               disabled: true,
               extra: {
                 optionList: [
                   { label: 'Yes', id: 1 },
                   { label: 'No', id: 2 },
                 ]
               },
             },
             {
               name: "accrual-period",
               label: "Accrual Period",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: [
                   { label: 'PPT + 0', id: 5 },
                   { label: 'PPT + 1', id: 6 },
                   { label: 'PPT + 2', id: 7 },
                   { label: 'PPT + 3', id: 8 },
                   { label: 'PPT + 4', id: 9 },
                   { label: 'PPT + 5', id: 10 },
                   { label: 'PPT + 6', id: 11 },
                   { label: 'PPT + 7', id: 12 },
                   { label: 'PPT + 8', id: 13 },
                   { label: 'PPT + 9', id: 14 },
                   { label: 'PPT + 10', id: 15 },
                 ]
               },
             },
             {
               name: "ROP",
               label: "ROP%",
               placeholder: "",
               disabled: false,
               extra: {
                 optionList: []
               },
             },
             // Riders
             {
               name: "ADB",
               label: "Accidental Death Benefit",
               placeholder: "",
               value: false,
               extra: {
                 hide: false,
                 description: Constants.ADB_RIDER_DESCRIPTION,
                 paramName: "ADBRider",
                 rider_name: "ADB Rider",
                 changeRiderStatus(form, data) {
                   let value = form.$("ADB").value;
                   form.$("ADB").value = !value;
     
                   if (form.$("ADB").value) {
                     form
                       .$("ADB-dropdown")
                       .set("value", Constants.RIDERS_DEFAULT_SA);
                   } else {
                     form.$("ADB-dropdown").set("value", "");
                   }
                 },
               },
             },
             {
               name: "ADB-dropdown",
               label: "Accidental Death Benefit",
               placeholder: "",
               value: "",
               extra: {
                 optionList: [],
                 onBlur(form, data) {
                   let value = form.$("ADB-dropdown").value
                   Utils.updateBi(keys.ADB_RIDER, value,data.data.package_id, form, data)
                 },
               },
             },
             {
               name: "ATPDRider",
               label: "Accidental Total and Permanent Disability",
               placeholder: "",
               value: false,
               extra: {
                 hide: false,
                 description: Constants.ATPD_RIDER_DESCRIPTION,
                 paramName: "ATPDRider",
                 rider_name: "ATPD Rider",
                 changeRiderStatus(form, data) {
                   let value = form.$("ATPDRider").value;
                   form.$("ATPDRider").value = !value;
     
                   if (form.$("ATPDRider").value) {
                     form
                       .$("ATPDRider-dropdown")
                       .set(
                         "value",
                         Constants.RIDERS_DEFAULT_SA
                       );
                   } else {
                     form.$("ATPDRider-dropdown").set("value", "");
                   }
                 },
               },
             },
             {
               name: "ATPDRider-dropdown",
               label: "Accidental Total and Permanent Disability",
               placeholder: "",
               value: "",
               extra: {
                 optionList: [],
                 onBlur(form, data) {
                   let value = form.$("ATPDRider-dropdown").value
                   Utils.updateBi(keys.ATPD_RIDER, value,data.data.package_id, form, data)
                 },
               },
             },
             {
               name: 'CriticalIllnessRider',
               label: 'Critical Illness',
               placeholder: '',
               value: false,
               extra: {
                 hide: false,
                 description: Constants.CRITICAL_ILLNESS_RIDER_DESCRIPTION,
                 paramName: 'CriticalIllnessRider',
                 rider_name: 'Critical Illness Rider',
                 changeRiderStatus(form, data) {
                   let value = form.$('CriticalIllnessRider').value
                   form.$('CriticalIllnessRider').value = !value
     
                   if (form.$('CriticalIllnessRider').value) {
                     form.$('CriticalIllnessRider-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                   } else {
                     form.$('CriticalIllnessRider-dropdown').set('value', "")
                   }
                 }
               }
             },
             {
               name: 'CriticalIllnessRider-dropdown',
               label: 'Critical Illness',
               placeholder: '',
               value: "",
               extra: {
                 optionList: [],
                 onBlur(form, data) {
                   let value = form.$("CriticalIllnessRider-dropdown").value
                   Utils.updateBi(keys.Critical_ILLNESS_RIDER, value,data.data.package_id, form, data)
                 },
               }
             },
             {
               name: 'IncomeBenefitRider',
               label: 'Income Benefit',
               placeholder: '',
               value: false,
               extra: {
                 hide: false,
                 description: Constants.INCOME_BENEFIT_RIDER_DESCRIPTION,
                 paramName: 'IncomeBenefitRider',
                 rider_name: 'Income Benefit Rider',
                 changeRiderStatus(form, data) {
                   let value = form.$('IncomeBenefitRider').value
                   form.$('IncomeBenefitRider').value = !value
     
                   if (form.$('IncomeBenefitRider').value) {
                     form.$('IncomeBenefitRider-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                   } else {
                     form.$('IncomeBenefitRider-dropdown').set('value', "")
                   }
                 }
               }
             },
             {
               name: 'IncomeBenefitRider-dropdown',
               label: 'Income Benefit',
               placeholder: '',
               value: "",
               extra: {
                 optionList: [],
                 onBlur(form, data) {
                   let value = form.$("IncomeBenefitRider-dropdown").value
                   Utils.updateBi(keys.INCOME_BENEFIT_RIDER, value,data.data.package_id, form, data)
                 },
               },
             },
             {
               name: 'WaiverOfPremiumRider',
               label: 'Waiver of Premium',
               placeholder: '',
               value: false,
               extra: {
                 hide: false,
                 description: Constants.WOP_RIDER_DESCRIPTION,
                 paramName: 'WaiverOfPremiumRider',
                 rider_name: 'Waiver of Premium Rider',
                 changeRiderStatus(form, data) {
                   let value = form.$('WaiverOfPremiumRider').value
                   form.$('WaiverOfPremiumRider').value = !value
     
                   let productId =data.data.package_id
                   let wopRiderValue = '';
     
                   if (!value) {
                     wopRiderValue = '1';
                   }
                   form.$('WaiverOfPremiumRider').value = !value
     
                   Utils.updateBi(keys.WOP_RIDER, wopRiderValue, productId, form, data)
                 }
               }
             },
             {
               name: 'WaiverOfPremiumRider-dropdown',
               label: 'Waiver of Premium',
               placeholder: '',
               value: {},
               extra: {
                 optionList: []
               }
             },
             {
               name: 'PayorWaiverBenefitRider',
               label: 'Payor Waiver Benefit',
               placeholder: '',
               value: false,
               extra: {
                 hide: false,
                 disabled: false,
                 description: Constants.PWB_RIDER_DESCRIPTION,
                 paramName: 'PayorWaiverBenefitRider',
                 rider_name: 'Payor Waiver Benefit Rider',
                 changeRiderStatus(form, data) {
                   let value = form.$('PayorWaiverBenefitRider').value
                   form.$('PayorWaiverBenefitRider').value = !value
     
                   if (form.$('PayorWaiverBenefitRider').value) {
                     form.$('PayorWaiverBenefitRider-dropdown').set('value', form.$('PayorWaiverBenefitRider-dropdown').extra.optionList[0])
                   } else {
                     form.$('PayorWaiverBenefitRider-dropdown').set('value', {})
                   }
                 }
               }
             },
             {
               name: 'PayorWaiverBenefitRider-dropdown',
               label: 'Payor Waiver Benefit',
               placeholder: '',
               value: {},
               extra: {
                 optionList: [
                   {
                     id: 1,
                     label: 'Option 1 (On Death)'
                   },
                   {
                     id: 2,
                     label: 'Option 2 (CI or ATPD)'
                   },
                   {
                     id: 3,
                     label: 'Option 3 (CI or ATPD or Death)'
                   }
                 ]
               }
             },
           ],
    };
  }

  setDefaults(data) {
    // Set forms initial default value
    setInitialDefaults(this, data.data)

    // Observer fields
    formObserver(this, data.data)
  }
}

export default FlexiDreamPlanFormController;
